<script setup lang="ts">
// os#231: the tool types a proposal needs that have no connection yet. Named, and linked to where the
// CEO makes the connection (`/tools`), so approving a plan that needs one is an informed choice, not a
// surprise the first run fails on. Approving anyway is still allowed — this only warns.
defineProps<{ missingConnections: string[] }>()
</script>

<template>
    <div v-if="missingConnections.length" class="tool-connections-warning" role="status">
        <p class="headline">
            This plan needs
            {{ missingConnections.length === 1 ? 'a connection' : 'connections' }}
            you have not made yet.
        </p>
        <ul class="missing">
            <li v-for="type in missingConnections" :key="type">
                <span class="tool">{{ type }}</span>
                is not connected
            </li>
        </ul>
        <a href="/tools" class="connect">Connect it in Tools</a>
        <p class="note">You can approve the plan anyway — its first run waits until the connection is made.</p>
    </div>
</template>

<style scoped>
.tool-connections-warning {
    border: 1px solid #e0a33a;
    border-radius: 8px;
    background: #fdf6e7;
    color: #5a4413;
    padding: 12px 14px;
    display: grid;
    gap: 6px;
}

.headline {
    margin: 0;
    font-weight: 600;
}

.missing {
    margin: 0;
    padding-left: 18px;
}

.tool {
    font-family: ui-monospace, monospace;
    font-weight: 600;
}

.connect {
    justify-self: start;
    color: #7a4b00;
    text-decoration: underline;
}

.note {
    margin: 0;
    font-size: 0.85em;
    opacity: 0.85;
}
</style>
